import Vue from 'vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
import VuetableFieldSequence from "vuetable-2/src/components/VuetableFieldSequence.vue";
import numeral from 'numeral'
import i18n from '@/plugins/i18n';

function formatNumber(value) {
    return numeral(value).format("0,0");
}

function formatNumberDigit(value) {
    return numeral(value).format("0,0.00");
}

export default [
    {
        id: 'ranking',
        name: 'ranking',
        title: i18n.t('Ranking'),
        width: "50px",
        titleClass: "right aligned",
        dataClass: "right aligned",
        // formatter: (data) => {
        //     return 'test' + data;
        // }
    },
    {
        // id: 'name',
        name: 'name',
        title: i18n.t('Sales Staff'),
        filterable: false,
        togglable: true,
        // formatter: (data) => {
        //     var html = '';
        //     return data.first_name;
        // }
    },

    {
        id: 'upsellTotal',
        name: 'upsellTotal',
        title: i18n.t('Number of Upsell Order'),
        filterable: true,
        togglable: true,
        // formatter: (data) => {
        //     return formatNumber(data.upsell);
        // }
    },
    {
        id: 'won',
        name: 'won',
        title: i18n.t('_Report.Won'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            var html = '<span class="text-success">'+ formatNumber(data) +'</span>';
            return html;
        }
    },
    {
        id: 'lost',
        name: 'lost',
        title: i18n.t('_Report.Lost'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            var html = '<span class="text-danger">'+ formatNumber(data) +'</span>';
            return html;
        }
    },
    {
        id: 'totalSales',
        name: 'totalSales',
        title: i18n.t('_Reports.Product Sales'),
        filterable: true,
        togglable: true,
        titleClass: "text-center",
        dataClass: "text-center",
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    }
];



// WEBPACK FOOTER //
// ./src/components/tenancy/admin/report/assets/js/top_product_sales_upsell_fields.js